import { z } from 'zod'
import { AdditionalChargeType } from 'src/lib/types/paymentSettings'

export const createChargeValidationSchema = (chargeType: AdditionalChargeType | null) => {
  if (chargeType === AdditionalChargeType.PERCENTAGE) {
    return z.object({
      chargeType: z.literal(AdditionalChargeType.PERCENTAGE),
      chargeValue: z
        .number()
        .min(0.01, 'Please enter charge value (must be greater than 0)')
        .max(100, 'Percentage must be between 0 and 100')
    })
  } else if (chargeType === AdditionalChargeType.FLAT) {
    return z.object({
      chargeType: z.literal(AdditionalChargeType.FLAT),
      chargeValue: z.number().min(0.01, 'Please enter charge value (must be greater than 0)')
    })
  }
  return z.object({
    chargeType: z.nativeEnum(AdditionalChargeType, { message: 'Please select charge type' }),
    chargeValue: z.number().min(0.01, 'Please enter charge value (must be greater than 0)')
  })
}
